export default __webpack_public_path__ + "media/images/new_year/header_1280x840_2-40c9b0a42e136a6d5c4e2a0d8bb4f3d4.webp";